import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as gasCompositionDailyListAction from "../../../store/report-gas-composition-daily/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  DELETE_RP_GC_DAILY_REPORT,
  GET_RP_GC_DAILY_REPORT,
  SAVE_LIST_RP_GC_DAILY_REPORT,
  SAVE_RP_GC_DAILY_REPORT,
  SEND_E_MAIL_GAS_COMPOSITION,
  baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import classnames from "classnames";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { withTranslation } from "react-i18next";

//i18n

function GasCompositionReport(props) {
  let history = useHistory();
  const location = useLocation();
  const gasCompositionDailyReportListReducer = useSelector(state => state.GasCompositionReportList)
  // console.log(gasCompositionDailyReportListReducer)
  const dispatch = useDispatch();
  const permission = getPermission();
  const searchObj = location?.state?.goBack == true ? gasCompositionDailyReportListReducer.modelSearch : { GCDAILY_DATE: new Date(), }; //วันลบ 1 .setDate(new Date().getDate() - 1)  
  // const createObj = { UPLOAD_DESC: "", };

  // const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);


  const [selectedFile, setSelectedFile] = useState(null);
  const [modelDeviceList, setModelDeviceList] = useState(location?.state?.goBack == true ? gasCompositionDailyReportListReducer.modelDeviceList : []);

  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    dispatch(gasCompositionDailyListAction.setModelDeviceListToState(modelDeviceList))
  }, [modelDeviceList])

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );
  // 
  const options = {
    page: location?.state?.goBack == true ? gasCompositionDailyReportListReducer.pagination.page : 1,
    sizePerPage: location?.state?.goBack == true ? gasCompositionDailyReportListReducer.pagination.sizePerPage : 100,
    onSizePerPageChange: (sizePerPage, page) => {
      dispatch(gasCompositionDailyListAction.setPaginationToState({ sizePerPage, page }))
    },
    onPageChange: (page, sizePerPage) => {
      dispatch(gasCompositionDailyListAction.setPaginationToState({ sizePerPage, page }))
    },
    paginationSize: 4,
    pageStartIndex: 1,


    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [

      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    // console.log(row)
    return (
      <div className="d-sm-flex align-items-center justify-content-center">
        {permission.vGCN && (
          <>
            <OverButton
              onClick={() => {
                gotoPageGasCompoDetail(row);
              }}
              color="info"
              icon="far fa-edit"
              label="Edit"
            />
            <OverButton
              onClick={() => {
                downloadExcel(row);
              }}
              // disabled
              color="success"
              icon="fas fa-file-download"
              label="Download Excel"
            />
          </>
        )}

        {permission.eGCN && (
          <>
            <OverButton
              onClick={() => {
                dispatch(
                  confirmAction.showConfirm(
                    "Do you want to send e-mail ?",
                    () => {
                      sendmailGCReport(row);
                    }
                  )
                );
              }}
              // onClick={() => {
              //   sendmailGCReport(row);
              // }}
              color="info"
              icon="mdi mdi-email-send fa-lg"
              label="Send E-mail"
            />
          </>
        )}

      </div>
    );
  };

  const sendmailGCReport = async (row) => {
    // let date = row.SHIFT_DAILY
    // console.log(row);
    dispatch(loadingAction.showLoading());
    try {
      // console.log(row.SHIFT_DAILY);
      let res = await post(SEND_E_MAIL_GAS_COMPOSITION, { GCDAILY_PID: row.PID });
      if (res.resultCode != 200) {
        dispatch(messageAction.showMessage(res.resultDescription));
      } else {
        dispatch(messageAction.showMessage("Sending email."));
        fetchData(searchModel);
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const CheckSentMail = (cellContent, row) => {
    let label = "";
    if (row.STATUS_EMAIL == 0) {
      label = "Wait to send e-mail";
    } else if (row.STATUS_EMAIL == 1) {
      label = "Sending";
    } else if (row.STATUS_EMAIL == 2) {
      label = "Failed to send e-mail";
    } else {
      label = "Send e-mail success";
    }

    return (
      <div>
        <label>
          {label}
        </label>
      </div>
    );
  };


  const gotoPageGasCompoDetail = row => {
    history.push("/gas-composition-report/" + row.PID + "/gas-composition-report-detail");
  };
  // Action Button//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  //Check active
  const CheckActive = (active) => {
    // console.log(type);
    let status = "";
    let color = "";

    if (active == 1) {
      status = "Active";
      color = "success";
    } else {
      status = "-";
      color = "";
    }

    return (
      <div>
        <span className={"badge badge-soft-" + color} style={{ fontSize: 12 }}>
          {status}
        </span>
      </div>
    );
  };
  //Check active

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      formatter: CountIndexRow,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
    {
      dataField: "GCDAILY_DATE",
      text: "Report Date",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
      sort: false,
    },
    // {
    //   dataField: "BALANCESHIPPER_NAME",
    //   text: "Shipper",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "30%",
    //    fontSize: "12px",
    //   },
    //   style: {
    //     width: "30%",
    //   },
    //   sort: false,
    // },
    {
      dataField: "GCDAILY_REV",
      text: "Summary Report Revision",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
      sort: false,
    },
    {
      dataField: "STATUS_EMAIL",
      text: "Status",
      headerAlign: "center",
      formatter: CheckSentMail,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: false,
    },

    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      formatter: ButtonAction,
      headerAlign: "center",
      align: "left",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    if (location?.state?.goBack != true) {
      resetSearch();
    }
    resetModel();
    // setModelDeviceList(listMockData);

    ///fixed header table
    let tableId = "gc-name-daily-report-table";
    let scrollY = 218;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  //Function CURL 

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const resetSearch = () => {
    setSearchModel({ GCDAILY_DATE: new Date(), });
    fetchData({ GCDAILY_DATE: new Date(), });
  };

  const resetModel = () => {
    // setCreateModel(createObj);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  const fetchData = async (searchData) => {
    dispatch(gasCompositionDailyListAction.setSearchToState(searchData))
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_RP_GC_DAILY_REPORT, { ...searchData, GCDAILY_DATE: moment(searchData.GCDAILY_DATE).format("YYYY-MM-DD") });
      // console.log(res);
      setModelDeviceList(res.data.rpGCDailyList.map(obj => ({
        ...obj,
        GCDAILY_DATE: moment(obj.GCDAILY_DATE).format("DD/MM/YYYY")
      }
      ))
      );

    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const downloadExcel = (row) => {
    // console.log(row);
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/Report/downloadGasCompositionReportFile?GCDAILY_PID=" + row.PID, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          'GasComposition_Report_' + row.GCDAILY_DATE + '.xlsx'
          // moment(row.GCDAILY_DATE).format("DD-MM-YYYY")
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });

  };

  //Function CURL 

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Gas Composition")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Report
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Gas Composition</li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      {/* <Row className="mt-3">
                        <Col sm="12">
                          <FormGroup className="row">
                            <Col sm={7}></Col>
                            <Col sm={5}>
                              <h5 className="mb-0 me-2 font-size-15 d-flex align-items-center justify-content-end">
                                เวลาที่ Active ข้อมูลล่าสุด : {activeTime.UPLOAD_DATE != "" && activeTime.UPLOAD_DATE != undefined && activeTime.UPLOAD_DATE != null ?
                                  moment(activeTime.UPLOAD_DATE).format("D/MM/YYYY, HH:mm:ss") : ""
                                }

                              </h5>
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row> */}

                      {/* <Row>
                        <Col sm="12">
                          <FormGroup className="row">
                            <Col sm={6}></Col>
                            <Col sm={6}>
                              <div className="d-flex align-items-center justify-content-end">
                                <Button
                                  onClick={() => onUploadClick()}
                                  color="primary"
                                  className="mt-3 w-md"
                                >
                                  &nbsp;&nbsp;&nbsp;
                                  <i className="fas fa-file-upload fa-lg"></i>
                                  &nbsp; Upload Booking Data &nbsp;&nbsp;&nbsp;
                                </Button>

                                <Button
                                  onClick={() => setVisibleSelectDate(true)}
                                  color="info"
                                  className="mt-3 ms-2 w-md"
                                // disabled
                                >
                                  <i className="mdi mdi-cloud-refresh fa-lg"></i>
                                  &nbsp; Manual Refresh
                                </Button>
                              </div>
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row> */}
                      {/* <Row className="mt-4">
                        <hr />
                      </Row> */}


                      <Row>
                        <Col sm="4">
                          <FormGroup className="row mt-2">
                            <Label className="col-sm-3 col-form-label d-flex align-items-center justify-content-end">
                              Report Date
                            </Label>
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "d/m/Y",
                                  dateFormat: "d/m/Y",
                                  maxDate: new Date(),
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      GCDAILY_DATE: value[0]

                                    })

                                }}
                                value={searchModel.GCDAILY_DATE}
                              />

                            </Col>
                          </FormGroup>
                        </Col>


                        <Col sm="4">
                          <FormGroup className="row">
                            <div className="d-flex align-items-center justify-content-start">
                              <Button color="info" className="mt-2"
                                onClick={() => onSearch()}
                              >
                                <i className="fas fa-search"></i>
                                &nbsp; Search
                              </Button>

                              <Button color="warning" className="mt-2 ms-2"
                                onClick={() => resetSearch()}
                              >
                                <i className="fas fa-redo-alt"></i>
                                &nbsp; Reset
                              </Button>


                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <hr />
                      </Row>


                      {/* <Row className="mt-5">
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              Gas Composition
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row> */}

                      {/* <Row className="mt-2">
                        <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1"> */}


                      <Row className="mt-2">
                        <Col sm="12">
                          <div>
                            <BootstrapTable
                              id="gc-name-daily-report-table"
                              keyField="PID"
                              data={modelDeviceList}
                              columns={columns}
                              headerClasses="header-style"
                              rowStyle={rowStyleFontWhite}
                              // defaultSorted={defaultSorted}
                              pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* </TabPane>
                        </TabContent>
                      </Row> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

            {/* Modal */}


          </Row>
        </Container>



      </div >
    </React.Fragment >
  );
}

GasCompositionReport.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ GasCompositionReport }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GasCompositionReport));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
